import styled from '@emotion/styled'
import { breakpoint, calcRem } from '../../__styling'

export const StyledFiftyOffPromoStrapContainer = styled.a<{
    hideOnMobileAndApp: boolean
}>(({ hideOnMobileAndApp }) => ({
    display: hideOnMobileAndApp ? 'none' : 'flex',
    position: 'relative',
    paddingBottom: calcRem(16),
    textDecoration: 'none',

    [breakpoint('lg')]: {
        display: 'flex',
    },
}))

export const StyledInnerContainer = styled('div')(() => ({
    display: 'flex',
    width: '100%',
    height: calcRem(64),
    zIndex: 1,

    padding: calcRem(0, 16),
    gap: calcRem(12),
    textAlign: 'center',
    justifyContent: 'center',
    alignItems: 'center',
    background:
        'linear-gradient(90deg, var(--color-brand-50, #043DE2) 53.06%, var(--color-brand-70, #010C77) 105.7%)',
    [breakpoint('xxs')]: {
        padding: calcRem(12, 24),
    },
}))

export const StyledFiftyOffTextImage = styled('img')(() => ({
    width: '100%',
    maxWidth: '540px',
    height: 'auto',
}))
